import axios from 'axios';
import * as user from './user';
import * as dashboard from './dashboard';
import * as reporting from './reporting';
import * as signup from './signup';
import * as login from './login';
import * as logout from './logout';
import * as superAdmin from './superAdmin';
import * as selfSignUp from './selfSignUp';
import * as support from './support';
import * as notification from './notification';
import * as rewards from './rewards';
import * as billing from './billing';
import * as calculator from './calculator';

axios.defaults.baseURL = process.env.REACT_APP_API_PATH;
export {
  user,
  dashboard,
  reporting,
  signup,
  login,
  logout,
  superAdmin,
  selfSignUp,
  support,
  notification,
  rewards,
  billing,
  calculator,
};
